import {
    DeserializeCallbackFunc,
    IModelSchema,
    IPropSchema,
    PropSchema
} from '@mintdata/mint-kit/impl/util/serializr/src/api/types';

export function GUARDED_NOOP(err:any):void
{
    if( err ) // unguarded error...
        throw new Error(err);
}

export function once(fn:any):() => void
{
    let fired:boolean = false;

    return function()
    {
        if( !fired )
        {
            fired = true;
            return fn.apply(null, arguments);
        }

        invariant(false, 'callback was invoked twice');
    };
}

export function invariant(cond:boolean, message:string = null):void
{
    if( !cond )
        throw new Error('[serializr] ' + (message || 'Illegal State'));
}

export function parallel(ar:Array<any>, processor:(value:any, done:DeserializeCallbackFunc, idx:number) => void, callback:DeserializeCallbackFunc):void
{
    // TODO: limit parallelization?
    if( ar.length === 0 )
        return void callback(null, []);

    const resultArray:Array<any> = [];
    let left:number = ar.length;
    let failed:boolean = false;

    const processorCb = function(idx:number, err:any, result:any):void
    {
        if( err )
        {
            if( !failed )
            {
                failed = true;
                callback(err);
            }
        }
        else
        {
            resultArray[idx] = result;

            if( --left === 0 )
                callback(null, resultArray);
        }
    };

    ar.forEach(function(value:any, idx:number):void
    {
        processor(value, processorCb.bind(null, idx), idx);
    });
}

export function isPrimitive(value:any):boolean
{
    if( value === null )
        return true;

    return typeof value !== 'object' && typeof value !== 'function';
}

export function isModelSchema(thing:any):boolean
{
    return thing && thing.factory && thing.props;
}

export function isPropSchema(thing:any):boolean
{
    return thing && thing.serializer && thing.deserializer;
}

export function isAliasedPropSchema(propSchema:PropSchema):boolean
{
    return typeof propSchema === 'object' && !!propSchema.jsonname;
}

export function isIdentifierPropSchema(propSchema:PropSchema):boolean
{
    return typeof propSchema === 'object' && propSchema.identifier === true;
}

export function isAssignableTo(actualType:IModelSchema, expectedType:IModelSchema):boolean
{
    while( actualType )
    {
        if( actualType === expectedType )
            return true;

        actualType = actualType.extends;
    }

    return false;
}

export function isMapLike(thing:any):boolean
{
    return thing && typeof thing.keys === 'function' && typeof thing.clear === 'function';
}

export function getIdentifierProp(modelSchema:IModelSchema):string
{
    invariant(isModelSchema(modelSchema));

    // optimization: cache this lookup
    while( modelSchema )
    {
        for( const propName in modelSchema.props )
            if( typeof modelSchema.props[propName] === 'object' && (modelSchema.props[propName] as IPropSchema).identifier === true )
                return propName;

        modelSchema = modelSchema.extends;
    }

    return null;
}
